import React from "react";
import { Badge } from "@/components/ui/badge";

const MAP = {
  New: "bg-blue-50 text-blue-700 border-blue-200",
  Contacted: "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Follow-up": "bg-amber-50 text-amber-700 border-amber-200",
  "Site Visit": "bg-purple-50 text-purple-700 border-purple-200",
  Quotation: "bg-sky-50 text-sky-700 border-sky-200",
  Negotiation: "bg-orange-50 text-orange-700 border-orange-200",
  Won: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Lost: "bg-rose-50 text-rose-700 border-rose-200",
  Open: "bg-rose-50 text-rose-700 border-rose-200",
  Assigned: "bg-amber-50 text-amber-700 border-amber-200",
  "In Progress": "bg-sky-50 text-sky-700 border-sky-200",
  Resolved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Closed: "bg-slate-50 text-slate-700 border-slate-200",
  Pending: "bg-amber-50 text-amber-700 border-amber-200",
  Completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Urgent: "bg-red-50 text-red-700 border-red-200",
  High: "bg-orange-50 text-orange-700 border-orange-200",
  Medium: "bg-amber-50 text-amber-700 border-amber-200",
  Low: "bg-slate-50 text-slate-600 border-slate-200",
  "Site Survey": "bg-blue-50 text-blue-700 border-blue-200",
  "Material Dispatched": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Structure Erected": "bg-purple-50 text-purple-700 border-purple-200",
  "Panels Mounted": "bg-sky-50 text-sky-700 border-sky-200",
  "Net Metering": "bg-amber-50 text-amber-700 border-amber-200",
  Commissioned: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export default function StatusBadge({ value }) {
  const cls = MAP[value] || "bg-slate-50 text-slate-700 border-slate-200";
  return (
    <Badge variant="outline" className={`${cls} font-medium`} data-testid={`status-badge-${(value||'').toLowerCase().replace(/\s+/g,'-')}`}>
      {value || "-"}
    </Badge>
  );
}
